















































import { Component, Vue, Prop } from "vue-property-decorator";
import Shexiang from "./system-contents/shexiang.vue";
import ShexiangKeyan from "./system-contents/shexiang-keyan.vue";
import Mianxiang from "./system-contents/mianxiang.vue";
import Maixiang from "./system-contents/maixiang.vue";
import Shoutu from "./system-contents/shoutu.vue";
import Toufatu from "./system-contents/toufatu.vue";
import Zhongyitizhi from "./system-contents/zhongyitizhi.vue";
import Sizhenhecan from "./system-contents/sizhenhecan.vue";
import Ertong from "./system-contents/ertong.vue";
import Laonian from "./system-contents/laonian.vue";
import Beiyun from "./system-contents/beiyun.vue";
import Yunqi from "./system-contents/yunqi.vue";
import Chanhou from "./system-contents/chanhou.vue";
import WeiJuejing from "./system-contents/weijuejing.vue";
@Component({
  components: {
    Shexiang,
    ShexiangKeyan,
    Mianxiang,
    Maixiang,
    Shoutu,
    Toufatu,
    Zhongyitizhi,
    Sizhenhecan,
    Ertong,
    Laonian,
    Beiyun,
    Yunqi,
    Chanhou,
    WeiJuejing
  }
})
export default class extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private detail: any;
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  private detailChange() {
    this.$emit("update:detail", this.detail);
  }
}
